/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { action, computed } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { isBlank } from "@ember/utils";
import { tagName } from "@ember-decorators/component";
import UppyUpload from "discourse/lib/uppy/uppy-upload";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";

@tagName("")
export default class AvatarUploader extends Component {
  uppyUpload = new UppyUpload(this, {
    id: "avatar-uploader",
    type: "avatar",
    validateUploadedFilesOptions: {
      imagesOnly: true,
    },
    uploadDone: (upload) => {
      this.setProperties({
        imageIsNotASquare: upload.width !== upload.height,
        uploadedAvatarTemplate: upload.url,
        uploadedAvatarId: upload.id,
      });

      this.done();
    },
    additionalParams: () => ({
      user_id: this.user_id,
    }),
  });

  imageIsNotASquare = false;

  @computed("uppyUpload.uploading", "uploadedAvatarId")
  get customAvatarUploaded() {
    return !this.uppyUpload.uploading && !isBlank(this.uploadedAvatarId);
  }

  @computed("uppyUpload.uploading", "uppyUpload.uploadProgress")
  get uploadLabel() {
    return this.uppyUpload.uploading
      ? `${i18n("uploading")} ${this.uppyUpload.uploadProgress}%`
      : i18n("upload");
  }

  @action
  chooseImage() {
    this.uppyUpload.openPicker();
  }

  <template>
    <span ...attributes>
      <input
        accept="image/*"
        aria-hidden="true"
        class="hidden-upload-field"
        disabled={{this.uppyUpload.uploading}}
        id="custom-profile-upload"
        type="file"
        {{didInsert this.uppyUpload.setup}}
      />
      <DButton
        class="btn-default avatar-uploader__button"
        data-avatar-upload-id={{this.uploadedAvatarId}}
        data-uploaded={{this.customAvatarUploaded}}
        @action={{this.chooseImage}}
        @disabled={{this.uppyUpload.uploading}}
        @icon="far-image"
        @title="user.change_avatar.upload_title"
        @translatedLabel={{this.uploadLabel}}
      />

      {{#if this.imageIsNotASquare}}
        <div class="warning">{{i18n
            "user.change_avatar.image_is_not_a_square"
          }}</div>
      {{/if}}
    </span>
  </template>
}
